
<mat-dialog-content class="mat-typography"> 
    <mat-grid-list cols="6" [rowHeight]="40" >
        <mat-grid-tile   style="height:10px !important; text-align: left !important;">           
                 <h1><strong>{{data.selectedItem.CustomerDescription}}</strong></h1> 
        </mat-grid-tile>
        <mat-grid-tile></mat-grid-tile>
        <mat-grid-tile></mat-grid-tile>
        <mat-grid-tile></mat-grid-tile>
       
        <mat-grid-tile [colspan]=2 style="height: fit-content; text-align: right !important;">           
            <strong >Booking number : {{data.selectedItem.BookingNumber}}</strong> 
        </mat-grid-tile>
      
    </mat-grid-list>
    <br>

    <mat-grid-list cols="6" [rowHeight]="60">
        <mat-grid-tile [colspan]=1 >
            <mat-form-field class="example-full-width">
                 <mat-label>Booking Amount</mat-label>
                 <mat-icon matPrefix>attach_money</mat-icon>
                 <input matInput  value="{{data.selectedItem.TotalPrice}}" [disabled]="true">
             </mat-form-field>
        </mat-grid-tile>
      <mat-grid-tile [colspan]=1 >
               <mat-form-field class="example-full-width">
                    <mat-label>Available Credit</mat-label>
                    <mat-icon matPrefix>attach_money</mat-icon>
                    <input matInput  value="{{data.selectedItem.CreditAvailable}}" [disabled]="true">
                </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile [colspan]=1>
            <mat-form-field class="example-full-width">
                <mat-label>User</mat-label>
                
                <input matInput  value="{{data.selectedItem.BookingUser}}" [disabled]="true">
            </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile [colspan]=1 >
            <mat-form-field class="example-full-width">
                <mat-label>Location  </mat-label>
                 
                <input matInput  value="100 - Atlanta Branch" [disabled]="true">
            </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile [colspan]=2 >
       
            <mat-label>Signature :</mat-label>    
            <!-- <input matInput  value="100 - Atlanta Branch" [disabled]="true">   -->
            <img width="150" height="auto" matInput  src="{{data.message}}" >
       
      </mat-grid-tile>

      <mat-grid-tile [colspan]=1 >
        <mat-form-field class="example-full-width">
            <mat-label>Remarks</mat-label>           
            <input matInput  value="{{data.selectedItem.Remarks.trim()}}" [disabled]="true">
        </mat-form-field> 
      </mat-grid-tile>
    </mat-grid-list> 

    <br>
    <br>

    <div class="row">
        <table id="DataTableBinding" class="table table-striped table-sm row-border hover">
            <thead>
                <tr>
                    <th>ProductId</th>
                    <th>Description</th>
                    <th>Quantity</th>
                    <th>Price</th>                
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>OnHand</th>
                    <th>Location</th>
                    <th>Uom</th>
                    <th>Position</th>
                    <th>Price level 1</th>
                    <th>Price level 2</th>
                    

                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of data.item" >
                    <td>{{row.ProductId}}</td>
                    <td>{{row.ProductDescription}}</td>
                    <td>{{row.Quantity}}</td>
                    <td>{{row.Price}}</td>
                    <td>{{row.StartDate | date:'MM/dd/yyyy'}}</td>
                    <td>{{row.EndDate | date:'MM/dd/yyyy'}}</td>
                    <td>{{row.OnHand}}</td>
                    <td>{{row.Location}}</td>
                    <td>{{row.SellUom}}</td>
                    <td>{{row.Position}}</td>
                    <td>{{row.PriceLevel1}}</td>
                    <td>{{row.PriceLevel2}}</td>
                
            </tbody>
        </table>

    </div>



  

</mat-dialog-content>




<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>





   

                

              

                
               